import React, { useState, useRef } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { useSelector, useDispatch } from "react-redux";
import { Cookies } from "react-cookie";
import ThuChiNgoaiLePrint from "components/GenericComponent/ContentPrint/ThuChiNgoaiLePrint";
import moment from "moment";
export const BtnXuatExcel = () => {
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiNgoaiLe
  );

  const componentRef = useRef();
  const [dataPrint, setDataPrint] = useState({});
  const xuatExcel = () => () => {
    let { tungay, denngay, ten, nhanvien, loaiphieu } = dataSearch;
    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }
    link = link +
      `thu-chi-ngoai-le/xuat-excel-danh-sach-thu-chi-ngoai-le-data?tungay=${tungay}&denngay=${denngay}&ten=${ten}&nhanvien=${nhanvien}&loaiphieu=${loaiphieu}`;
    API_AUTH.get(link).then((res) => {
      setDataPrint(res.data);
      setTimeout(downExcel(), 2000);
    });
  };

  const downExcel = () => {
    var uri =
      "data:application/vnd.ms-excel," +
      encodeURIComponent(document.getElementById("htmlExcel").outerHTML);
    var downloadLink = document.createElement("a");
    downloadLink.href = uri;
    downloadLink.download =
      "ThuChiNgoaiLe_" + moment().format("YYYYMMDDHHmm") + ".xls";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  return (
    <>
      <a
        href={() => false}
        className="icon-bgnew color-print1"
        onClick={xuatExcel()}
      >
        <PopoversBootrap
          contentText="Xuất Excel"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
         <img src="/app-assets/images/icon-tai-xuong-v2.png" />
        </PopoversBootrap>
      </a>
      <div style={{ display: "none", color:"#000000" }}> 
      <ThuChiNgoaiLePrint ref={componentRef} dataPrint={dataPrint} />
      </div>
    </>
  );
};
